import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAddonPurchaseRequest, IAddonPurchaseResponse } from "../../interfaces";
import { useAuth } from "../helper/useAuth";

export const usePurchaseAddon = () => {
  const queryClient = useQueryClient();
  const { refreshUser } = useAuth();

  return useMutation<IAddonPurchaseResponse, Error, IAddonPurchaseRequest>({
    mutationFn: async (payload: IAddonPurchaseRequest) => {
      return await httpService.post<IAddonPurchaseResponse>(
        API_CONFIG.path.stripeAddonPurchase,
        payload as unknown as Record<string, unknown>
      );
    },
    onSuccess: () => {
      refreshUser();
      queryClient.invalidateQueries({ queryKey: ["billing", "addons"] });
      queryClient.invalidateQueries({ queryKey: ["stripe", "history"] });
    },
  });
};
